import { ProductManual } from "domain/productManuals";
import { CombinedTier } from "domain/tenants";

export interface Versions {
    version: string;
    downloadUrl: string;
    sha256?: string;
}
export interface SoftwarePackageDto {
    productName: string;
    licenseIds: (number | string)[];
    versions: Versions[];
    bmpHomeGroup?: string;
    bmpHomeCategory?: string;
    bmpHomeUseCases?: BmpHomeUseCase[];
    bpmHomeTargets?: BpmHomeTarget[];
    bmpHomeOperatingSystems?: BmpHomeOperatingSystem[];
    bmpHomeProcessors?: BmpHomeProcessor[];
}
export interface OnBoardingImagesDto {
    licenseId: number;
    manual: string;
    workflow: string;
    shaForManual: string;
    manualProductName: string;
    shaForWorkflow?: string;
}
export interface SoftwarePackagesDataDto {
    productDownloads: SoftwarePackageDto[];
    onboardingImages: OnBoardingImagesDto[];
}

export interface SoftwarePackage {
    productName: string;
    licenseIds: string[];
    versions: Versions[];
    bmpHomeGroup?: string;
    bmpHomeCategory?: string;
    bundles?: CombinedTier[];
    bmpHomeUseCases?: BmpHomeUseCase[];
    bpmHomeTargets?: BpmHomeTarget[];
    bmpHomeOperatingSystems?: BmpHomeOperatingSystem[];
    bmpHomeProcessors?: BmpHomeProcessor[];
}

export interface SoftwarePackagesData {
    productDownloads: SoftwarePackage[];
    onboardingImages: OnboardingImage[];
}

export interface SoftwarePackageHomePage extends SoftwarePackage {
    description?: string;
    onboarding?: string;
    manualsDownloads?: ProductManual;
}

export interface OnboardingImage {
    licenseId: number;
    manual: string;
    workflow?: string;
    shaForManual?: string;
    shaForWorkflow?: string;
    manualProductName: string;
}

export enum BmpHomeUseCase {
    DATA_CENTER = "data_center",
    ENDPOINT = "endpoint",
    MOBILE = "mobile",
}

export enum BpmHomeTarget {
    AIRPOD = "airpod",
    FILE_ACTIVE_DATA = "file_active_data",
    LAPTOP_DESKTOP = "laptop_desktop",
    LOOSE_DRIVES = "loose_drives",
    REMOVABLE_MEDIA = "removable_media",
    SERVERS = "servers",
    SMARTPHONES = "smartphones",
    STORAGE = "storage",
    STORAGE_ARRAY = "storage_array",
    TABLETS = "tablets",
    VIRTUAL_MACHINE = "virtual_machine",
    WEARABLES = "wearables",
}

export enum BmpHomeOperatingSystem {
    AGNOSTIC = "agnostic",
    ANDROID = "android",
    CHROMIUM_OS = "chromium_os",
    IOS = "ios",
    IPAD_OS = "ipad_os",
    MAC = "mac",
    NOT_APPLICABLE = "not_applicable",
    OTHER_HYPERVISORS = "other_hypervisors",
    WEAR_OS = "wear_os",
    WINDOWS = "windows",
}

export enum BmpHomeProcessor {
    APPLE_SILICON = "apple_silicon",
    ARM = "arm",
    NOT_APPLICABLE = "not_applicable",
    T2_X86_64 = "t2_x86_64",
    WINDOWS_ARM = "windows_arm",
    X86_64 = "x86_64",
}
